import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  tableContainer: {
    width: '100%',
    margin: '0',
    overflowY: 'scroll', // Enable vertical scrolling
    '&::-webkit-scrollbar': {
      display: 'none', // Hide scrollbar in WebKit browsers (Chrome, Safari)
    },
    '-ms-overflow-style': 'none', // Hide scrollbar in Internet Explorer and Edge
    'scrollbar-width': 'none', // Hide scrollbar in Firefox
  },
  tableRow: {
    '& td, & th': {
      border: 0,
    },
  },
  tableHeader: {
    '& td, & th': {
      border: 0,
    },
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1000,
  },
  tableBody: {},
  tableCell: {
    [`&.${tableCellClasses.head}`]: {
      color: alpha(theme.palette.common.white, 0.4),
    },
    [`&.${tableCellClasses.body}`]: {
      color: theme.palette.common.white,
    },
  },
  tableWrapper: {
    backgroundColor: theme.palette.background.paper,
    '& tr:nth-of-type(odd)': {
      backgroundColor: alpha(theme.palette.common.white, 0.04),
    },
    padding: '100px',
  },
}));

export default useStyles;
